<template>
  <div class="sidebar">
    <div class="sidebar-header">
      <div class="logo">
        <span class="logo-icon">🏥</span>
        <span class="logo-text">药通宝后台</span>
      </div>
    </div>
    
    <nav class="sidebar-nav">
      <router-link to="/dashboard" class="nav-item" exact-active-class="active">
        <span class="nav-icon">📊</span>
        <span class="nav-label">首页概览</span>
      </router-link>
      <router-link to="/suggestions" class="nav-item" active-class="active">
        <span class="nav-icon">💡</span>
        <span class="nav-label">建议反馈</span>
      </router-link>
      <router-link to="/trading" class="nav-item" active-class="active">
        <span class="nav-icon">🛒</span>
        <span class="nav-label">采销信息</span>
      </router-link>
      <router-link to="/activities" class="nav-item" active-class="active">
        <span class="nav-icon">📢</span>
        <span class="nav-label">活动管理</span>
      </router-link>
      <router-link to="/policy-files" class="nav-item" active-class="active">
        <span class="nav-icon">📚</span>
        <span class="nav-label">知识库</span>
      </router-link>
      <router-link to="/users" class="nav-item" active-class="active">
        <span class="nav-icon">👥</span>
        <span class="nav-label">用户管理</span>
      </router-link>
      <router-link to="/gap-bases" class="nav-item" active-class="active">
        <span class="nav-icon">🌱</span>
        <span class="nav-label">GAP基地</span>
      </router-link>
      <router-link to="/daodi-herbs" class="nav-item" active-class="active">
        <span class="nav-icon">🌿</span>
        <span class="nav-label">道地药材</span>
      </router-link>
      <router-link to="/pharmacopoeia-2025" class="nav-item" active-class="active">
        <span class="nav-icon">📖</span>
        <span class="nav-label">2025版药典</span>
      </router-link>
      <router-link to="/collection-schemes" class="nav-item" active-class="active">
        <span class="nav-icon">📦</span>
        <span class="nav-label">集采品种</span>
      </router-link>
      <router-link to="/xianxian-herbs" class="nav-item" active-class="active">
        <span class="nav-icon">🌱</span>
        <span class="nav-label">趁鲜药材</span>
      </router-link>
      <router-link to="/market-prices" class="nav-item" active-class="active">
        <span class="nav-icon">📈</span>
        <span class="nav-label">市场价格</span>
      </router-link>
      <router-link to="/origin-prices" class="nav-item" active-class="active">
        <span class="nav-icon">📍</span>
        <span class="nav-label">产地价格</span>
      </router-link>
      <router-link to="/crawl-logs" class="nav-item" active-class="active">
        <span class="nav-icon">📊</span>
        <span class="nav-label">采集日志</span>
      </router-link>
      <router-link to="/industry" class="nav-item" active-class="active">
        <span class="nav-icon">🔗</span>
        <span class="nav-label">产业链</span>
      </router-link>
      <router-link to="/inquiries" class="nav-item" active-class="active">
        <span class="nav-icon">❓</span>
        <span class="nav-label">问询记录</span>
      </router-link>
      <router-link to="/yaoxie" class="nav-item" active-class="active">
        <span class="nav-icon">📋</span>
        <span class="nav-label">食药同源</span>
      </router-link>
    </nav>

    <div class="sidebar-footer">
      <button class="logout-btn" @click="handleLogout">
        <span class="btn-icon">🚪</span>
        <span>退出登录</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',
  methods: {
    handleLogout() {
      localStorage.removeItem('adminLoggedIn')
      sessionStorage.removeItem('adminPassword')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.sidebar {
  width: 260px;
  height: 100vh;
  background: #1e293b;
  color: #e0e6ed;
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  top: 0;
  box-shadow: 4px 0 20px rgba(0, 0, 0, 0.3);
  z-index: 100;
}

.sidebar-header {
  padding: 24px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-icon {
  font-size: 28px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
}

.logo-text {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.5px;
}

.sidebar-nav {
  flex: 1;
  padding: 16px 12px;
  overflow-y: auto;
}

.nav-item {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  margin: 2px 0;
  color: #fff;
  text-decoration: none;
  border-radius: 10px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.nav-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 3px;
  height: 100%;
  background: linear-gradient(180deg, #3b82f6 0%, #2563eb 100%);
  opacity: 0;
  transition: opacity 0.25s ease;
}

.nav-item:hover {
  background: rgba(255, 255, 255, 0.06);
  color: #e0e6ed;
}

.nav-item.active {
  background: linear-gradient(90deg, rgba(59, 130, 246, 0.15) 0%, rgba(59, 130, 246, 0.05) 100%);
  color: #3b82f6;
}

.nav-item.active::before {
  opacity: 1;
}

.nav-icon {
  font-size: 18px;
  margin-right: 12px;
  width: 24px;
  text-align: center;
  transition: transform 0.2s ease;
}

.nav-item:hover .nav-icon {
  transform: scale(1.1);
}

.nav-label {
  font-size: 14px;
  font-weight: 500;
}

.sidebar-footer {
  padding: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.logout-btn {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 20px;
  background: linear-gradient(135deg, #dc2626 0%, #b91c1c 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.25s ease;
  box-shadow: 0 2px 8px rgba(220, 38, 38, 0.3);
}

.logout-btn:hover {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(220, 38, 38, 0.4);
}

.logout-btn:active {
  transform: translateY(0);
}

.btn-icon {
  font-size: 16px;
}

/* Scrollbar styling */
.sidebar-nav::-webkit-scrollbar {
  width: 4px;
}

.sidebar-nav::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar-nav::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
}

.sidebar-nav::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.2);
}
</style>